import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { setObligation } from 'store/entities/submissions';
import { isValidButtonInputEvent } from 'utils/accessibilityUtils';
import useSearchSubmissions from 'utils/hooks/submissions/useSearchSubmissions';

import Icon from '@mdi/react';
import { mdiClose, mdiMagnify } from '@mdi/js';

import { Control, Field, Input, Label } from 'components/UIComponents/Form';
import { Column } from 'components/UIComponents/Layout';

const SearchBox = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { obligation, submissionsListLoading } = useSelector(
    state => state.submissions
  );

  const doSearch = useSearchSubmissions();

  const search = (e, disabledKeyCodes) =>
    isValidButtonInputEvent(e, disabledKeyCodes) && doSearch();

  const clearSearch = e => {
    if (isValidButtonInputEvent(e)) {
      dispatch(setObligation(''));
      doSearch('');
    }
  };

  return (
    <Column tablet={{ size: 6 }} desktop={{ size: 12 }} fullhd={{ size: 5 }}>
      <Field>
        <Control>
          <Label htmlFor="obligationSearch">
            {t('datagate.external.submissions.filter.obligation.label')}
          </Label>
          <Control iconRight iconLeft>
            <Input
              disabled={submissionsListLoading}
              placeholder={t(
                'datagate.external.submissions.filter.obligation.placeholder'
              )}
              onChange={e => dispatch(setObligation(e.target.value))}
              onKeyUp={e => search(e, [32])}
              value={obligation}
              id="obligationSearch"
            />
            <span
              className="icon is-left"
              onClick={clearSearch}
              onKeyUp={clearSearch}
              role="button"
              tabIndex="0"
              aria-label="Clear search button"
              id="clearSearchButton"
            >
              <Icon path={mdiClose} size={0.8} />
            </span>
            <span
              className="icon is-right"
              onClick={search}
              onKeyUp={search}
              role="button"
              tabIndex="0"
              aria-label="Search button"
              id="searchButton"
            >
              <Icon path={mdiMagnify} size={1} />
            </span>
          </Control>
        </Control>
      </Field>
    </Column>
  );
};

export default SearchBox;
